import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6t39gkkzh: FaireProductEntity = {
  token: "p_y6t39gkkzh",
  type: "product",
  name: "Thank You No. 05",
  brandToken: "b_umfa9a7xcn",
  brandName: "Jaymes Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/cd56e8f89ca40e1a5c828e1697caede03c0a5dadcac721966b8183ef482bdf39.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf8518addf0e42697d43963f11e65e21f107a192973d6ad329353dc36499202a.jpeg",
    "https://cdn.faire.com/fastly/b4195a07bd128a273f85f00cf0d24ab0aca32efe4b1e6158b38a453f63e6b055.jpeg",
    "https://cdn.faire.com/fastly/384ae0b6dff645e839f0696b197acbe9c4e353dc8976b0c29083d4c973a47eb9.jpeg",
    "https://cdn.faire.com/fastly/9cc19c0d6cf35f5bccc155ab091b3ee0bba28318711b098de4bf094908d822d4.jpeg",
    "https://cdn.faire.com/fastly/45a52c106be9e5e25198038394d3b62da09165112ea6e09739abd41c6e8be1e1.jpeg",
    "https://cdn.faire.com/fastly/147b36582bd385f70d9dff922531f22108e330d01f76e4b18f107a22b8d5f469.jpeg",
  ],
  priceDollars: 3,
  description:
    '• A2 Folded 4.25" L × 5.5" W\n• "So Very Grateful For You"\n• Natural Cover Stock\n• Digitally Printed\n• Natural Envelope\n• Blank interior\n• Made in Los Angeles',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:24.584Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
